import { RemoteConfigLoader } from "./RemoteConfigLoader"

export type Endpoint = "api" | "aggregator" | "power-simulator" | "sensor-config"

/**
 *
 */
type ConfigContent = {
    AGGREGATOR_URL: string,
    API_URL: string,
    SENSOR_CONFIG_URL: string,
    SIMULATOR_URL: string,
    UNBATCH_FOR_AWS: string,
}
/**
 * Url Configuration helper class
 */
class UrlConfigIn extends RemoteConfigLoader<ConfigContent> {
    protected url: string = "/url-config.json"

    /**
     * Gets the base url from server config, if possible
     * @param endpoint
     * @returns
     */
    private async getConfiguredBaseUrl(endpoint: Endpoint) {
        const config = await this.getConfig()

        if (!config) {
            return null
        }
        switch (endpoint) {
            case "api":
                return config.API_URL
            case "aggregator":
                return config.AGGREGATOR_URL
            case "power-simulator":
                return config.SIMULATOR_URL
            case "sensor-config":
                return config.SENSOR_CONFIG_URL
        }
    }

    /**
     * Gets base url
     * @param endpoint
     */
    private getDefaultBaseUrl(endpoint: Endpoint) {
        switch (endpoint) {
            case "api":
                return process.env.VUE_APP_DEFAULT_SERVER_URL as string
            case "aggregator":
                return process.env.VUE_APP_DEFAULT_AGGREGATOR_URL as string
            case "power-simulator":
                return process.env.VUE_APP_DEFAULT_SIMULATOR_URL as string
            case "sensor-config":
                return process.env.VUE_APP_DEFAULT_SENSOR_CONFIG_URL as string
        }
    }

    /**
     * Gets base url
     * @param endpoint
     */
    public async getBaseUrl(endpoint: Endpoint) {
        const configuredBaseUrl = await this.getConfiguredBaseUrl(endpoint)
        return configuredBaseUrl || this.getDefaultBaseUrl(endpoint)
    }

    /**
     *
     */
    public async shouldUnbatchForAWS() {
        const config = await UrlConfig.getConfig()
        return config?.UNBATCH_FOR_AWS ??
            !!process.env.VUE_APP_DEFAULT_UNBATCH_FOR_AWS
    }
}

export const UrlConfig = new UrlConfigIn()